function changeRequesterDialogDirective () {
  return {
    retrict: 'E',
    templateUrl: '/workflow/dialogs/change-requester/change-requester-dialog.html?$$REVISION$$'
  }
}

export { changeRequesterDialogDirective }
